export default {
  title: '! Comenzi oprite până la {{time}}',
  button: 'Reactivează',
  labels: {
    rest_of_day: 'restul zilei',
  },
};
